module.exports = __webpack_public_path__ + "img/bg_right_botom@2x.565dfdb3.png";